export enum AdminActionEnum {
  DELETE = 'Delete',
}

export const AdminActions = Object.values(AdminActionEnum);
